import { integerValue, isMinimum } from '~/utils';

const isPhone = value => value && isMinimum(integerValue(value), 8) && 'Telefone inválido!';

export default isPhone;
